import React, {FC, useState} from 'react';

import {
    PayOverTimeLocations,
    PAYER_ID,
    PAYPAL_MODAL_LINK,
    PaypalIframeTypes,
} from 'constants/payOverTime';

import {sendAnalytics} from '../../analytics';
import {PayPalModal} from '../../payPalModal/payPalModal';

import s from '../buttons.scss';

type PropsType = {
    type: PaypalIframeTypes;
    amount: number;
    location: PayOverTimeLocations;
};

/**
 * for open the paypal custom iframe popup
 */
export const PaypalButton: FC<PropsType> = ({amount, location, type}) => {
    const [isOpened, setIsOpened] = useState(false);

    const mappings: Record<PaypalIframeTypes, string> = {
        [PaypalIframeTypes.PAY_LATER_LONG_TERM]: 'PayPal - Pay Monthly',
        [PaypalIframeTypes.PAY_LATER_SHORT_TERM]: 'PayPal - Pay in 4',
        [PaypalIframeTypes.PAYPAL_CREDIT_NO_INTEREST]: 'PayPal - Credit',
    };

    const handelClick = () => {
        sendAnalytics(location, mappings[type]);
        setIsOpened(true);
    };

    const payPalIframeURL = `${PAYPAL_MODAL_LINK}payer_id=${PAYER_ID}&offer=${type}&buyer_country=US&amount=${amount}`;

    return (
        <>
            <button className={s.learnMore} onClick={handelClick} type="button">
                Learn more
            </button>
            <PayPalModal
                closePopup={() => setIsOpened(false)}
                isOpened={isOpened}
                payPalIframeURL={payPalIframeURL}
            />
        </>
    );
};
